var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5874_7536)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_5874_7536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9582 22L26.4791 19.5352M21.9582 22L17.4791 19.5352M21.9582 22L22 27M20.896 12.559L14.0078 16.4946C13.3846 16.8506 13 17.5133 13 18.2311V25.7582C13 26.4817 13.3907 27.1487 14.0218 27.5026L21.0728 31.4566C21.6754 31.7945 22.4099 31.7975 23.0152 31.4643L29.9642 27.6403C30.6031 27.2888 31 26.6174 31 25.8881V18.2471C31 17.5208 30.6063 16.8516 29.9714 16.4988L22.8596 12.5473C22.2481 12.2076 21.5035 12.212 20.896 12.559Z",
    stroke: "#1B202C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5874_7536",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5874_7536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockSquare);
export default __webpack_public_path__ + "static/media/block-square.6f7f6e4d70e1d9b5dba553aeca529a27.svg";
export { ForwardRef as ReactComponent };